export default __webpack_public_path__ + "static/slider-img1-22296d55761dbeb3444eb888c54b98a1.jpg";